/**
 * NotFoundPage - 404 real en lugar de redirect silencioso.
 */
import { Link, useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Compass } from "lucide-react";
import Button from "@/components/ui/Button";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <div className="w-24 h-24 rounded-full bg-primary-100 flex items-center justify-center">
            <Compass className="w-12 h-12 text-primary-600" />
          </div>
        </div>
        <h1 className="text-7xl font-bold text-gray-900 mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Página no encontrada
        </h2>
        <p className="text-gray-600 mb-8">
          La página que buscas no existe o fue movida. Verifica el enlace o
          vuelve al inicio.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft className="w-4 h-4" />}
          >
            Volver atrás
          </Button>
          <Link to="/dashboard">
            <Button variant="primary" icon={<Home className="w-4 h-4" />}>
              Ir al Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
